(function() {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // ── 1. Keycap 3D Buttons ──
  function initKeycapButtons() {
    var selectors = [
      '.kc-hero-btn',
      '.kc-discord-btn',
      '#kc-promo-explain .kc-step-num'
    ];
    var btns = document.querySelectorAll(selectors.join(','));
    btns.forEach(function(btn) {
      btn.classList.add('kc-btn-3d');
      if (btn.closest('#kc-story') || btn.closest('.kc-discord') || btn.closest('#kc-promo-explain')) {
        btn.classList.add('kc-btn-3d--dark');
      }
    });
  }

  // ── 2. Typing Animation ──
  function initTyping() {
    var el = document.querySelector('.kc-hero-title');
    if (!el) return;

    var text = el.textContent.trim();
    el.textContent = '';
    el.style.minHeight = el.offsetHeight + 'px';

    var cursor = document.createElement('span');
    cursor.className = 'kc-typing-cursor';
    cursor.innerHTML = '&nbsp;';
    el.appendChild(cursor);

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        typeText(el, text, cursor, 0);
      });
    }, { threshold: 0.3 });

    observer.observe(el);
  }

  function typeText(el, text, cursor, i) {
    if (i >= text.length) {
      cursor.classList.add('kc-typing-cursor--done');
      setTimeout(function() { cursor.remove(); }, 3000);
      return;
    }
    el.insertBefore(document.createTextNode(text[i]), cursor);
    var delay = text[i] === ' ' ? 30 : (40 + Math.random() * 60);
    setTimeout(function() { typeText(el, text, cursor, i + 1); }, delay);
  }

  // ── 3. Product Card Press ──
  function initCardPress() {
    var cards = document.querySelectorAll('.grid-view-item, .grid-product, .kc-story-card');
    cards.forEach(function(card) {
      card.classList.add('kc-card-press');
    });
  }

  // ── 4. Easter Egg: type "keycap" ──
  var eggBuffer = '';
  var eggWord = 'keycap';
  var eggActive = false;

  function initEasterEgg() {
    document.addEventListener('keydown', function(e) {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      eggBuffer += e.key.toLowerCase();
      if (eggBuffer.length > eggWord.length) {
        eggBuffer = eggBuffer.slice(-eggWord.length);
      }
      if (eggBuffer === eggWord && !eggActive) {
        eggActive = true;
        spawnKeycapRain();
        setTimeout(function() { eggActive = false; }, 4000);
      }
    });
  }

  function spawnKeycapRain() {
    var count = 24;
    for (var i = 0; i < count; i++) {
      (function(idx) {
        setTimeout(function() {
          var cap = document.createElement('div');
          cap.className = 'kc-rain-cap';
          var x = Math.random() * window.innerWidth;
          var rot = 90 + Math.random() * 270;
          var duration = 1.5 + Math.random() * 2;
          var size = 28 + Math.random() * 20;
          cap.style.left = x + 'px';
          cap.style.top = '-60px';
          cap.style.width = size + 'px';
          cap.style.height = size + 'px';
          cap.style.setProperty('--kc-rot', rot + 'deg');
          cap.style.animationDuration = duration + 's';
          document.body.appendChild(cap);
          setTimeout(function() { cap.remove(); }, duration * 1000 + 100);
        }, idx * 80);
      })(i);
    }
  }

  // ── 5. Click Ripple ──
  function initClickRipple() {
    document.addEventListener('click', function(e) {
      var ripple = document.createElement('div');
      ripple.className = 'kc-click-ripple';
      ripple.style.left = e.clientX + 'px';
      ripple.style.top = e.clientY + 'px';
      document.body.appendChild(ripple);
      setTimeout(function() { ripple.remove(); }, 500);
    });
  }

  // ── 6. Scroll Reveal ──
  function initScrollReveal() {
    var items = document.querySelectorAll(
      '.kc-story-card, .kc-promo-step, .kc-stat, .kc-reveal, .ko-pcard, .ko-proc__step'
    );
    items.forEach(function(item, i) {
      item.classList.add('kc-reveal');
      item.classList.add('kc-reveal-delay-' + ((i % 3) + 1));
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kc-visible');
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function(item) { observer.observe(item); });
  }

  // ── Init ──
  function init() {
    initKeycapButtons();
    initTyping();
    initCardPress();
    initEasterEgg();
    initClickRipple();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
